// extracted by mini-css-extract-plugin
export default {"description":"VerifyPhone_description__aUbnA","first_txt":"VerifyPhone_first_txt__M9mZM","lst_txt":"VerifyPhone_lst_txt__tAyZI"};